import { createClient } from "@supabase/supabase-js";
import { Database } from "./database.types";

export const defaultSupabaseClient = createClient<Database>(
    "https://umgzmsluivbzszvnghyb.supabase.co",
    "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InVtZ3ptc2x1aXZienN6dm5naHliIiwicm9sZSI6ImFub24iLCJpYXQiOjE2OTM2NDI4ODksImV4cCI6MjAwOTIxODg4OX0.xwqSaxbEtzYfrU-xxYB02ilTT_QhMUPAWkROBfPDKMg"
  );